// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.o0Y9C{max-width:600px}@media(max-width: 767px){.o0Y9C{max-width:unset}}@media(orientation: landscape)and (max-width: 823px){.o0Y9C{max-width:unset}}.Wa4tJ{margin:0 auto;width:40%}@media(max-width: 767px){.Wa4tJ{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": "o0Y9C",
	"actions": "Wa4tJ"
};
module.exports = ___CSS_LOADER_EXPORT___;
